import { CustomLeaderboard } from "@/components/Creators/CustomLeaderboard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/customLeaderboard",
)({
  component: CustomLeaderboardComponent,
  beforeLoad: () => ({
    title: "Custom Leaderboard",
  }),
});

function CustomLeaderboardComponent() {
  return (
    <div className="h-full w-full">
      <CustomLeaderboard />
    </div>
  );
}
